// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".G6JBXZTdJ1ojhuJFC_Lv{width:100%;display:flex;justify-content:space-between;align-items:center}.G6JBXZTdJ1ojhuJFC_Lv>button{display:flex;justify-content:space-between;align-items:center;column-gap:8px;font-size:14px;padding-top:8px;padding-bottom:8px;width:105px}.G6JBXZTdJ1ojhuJFC_Lv>button svg{stroke:currentColor}@media(min-width: 768px){.G6JBXZTdJ1ojhuJFC_Lv{display:none}}.iBebex9CrkS93AfrRuMQ{display:none}@media(min-width: 768px){.iBebex9CrkS93AfrRuMQ{display:block}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paginationMobile": "G6JBXZTdJ1ojhuJFC_Lv",
	"paginationDesktop": "iBebex9CrkS93AfrRuMQ"
};
export default ___CSS_LOADER_EXPORT___;
